import { MonEventsServiceFactory, MonEventsServiceInterface } from '@monsido_services/services/mon-events/dist/mon-events.service';
import { Injectable } from '@angular/core';
import { EventsType } from '@monsido/services/mon-event/events.type';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';

@Injectable()
export class MonEventService {
    static ONCE_EVENTS: EventsType[] = [
        MON_EVENTS.LOAD_DIALOG,
        MON_EVENTS.CLOSE_ALL_DIALOGS,
        MON_EVENTS.LOAD_NG2_DIALOG,
    ];

    onceEventsListenerIdMap: Map<EventsType, number> = new Map();
    monEvents: MonEventsServiceInterface = MonEventsServiceFactory();

    // HACK: fn actually takes async functions instead of just sync functions. Making it any for now
    addListener (type: EventsType, fn: (...args) => any): number {
        if (this.onceEventsListenerIdMap.has(type)) {
            return this.onceEventsListenerIdMap.get(type) as number;
        }

        const listenerId = this.monEvents.addListener(type, fn);
        if (MonEventService.ONCE_EVENTS.includes(type)) {
            this.onceEventsListenerIdMap.set(type, listenerId);
        }

        return listenerId;
    }

    run (...args: Array<unknown>): Promise<void[] | void> {
        try {
            return this.monEvents.run(...args);
        } catch (e) {
            return Promise.resolve();
        }
    }

    remove (id: number): void {
        this.monEvents.remove(id);
    }

    resetOnceEvents (): void {
        this.onceEventsListenerIdMap.clear();
    }
}
